


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import FlipNumberItem from "@/components/number/FlipNumberItem.vue";

@Component({
  components: { FlipNumberItem },
})
export default class FlipNumber extends Vue {
  @Prop({ default: "0" }) private readonly value!: string;
  @Prop({ default: 100 }) private readonly interval!: number;
  numbersSplitted: number[] = [];

  created() {
    this.splitValue();
  }

  @Watch("value")
  splitValue() {
    this.numbersSplitted = [];
    if (isNaN(Number(this.value))) {
      return console.error("the prop must be a number");
    }
    const valueSplittedArr = this.value.toString().split("");
    for (let i = 0; i < valueSplittedArr.length; i++) {
      let _val = valueSplittedArr[i];
      if (isNaN(Number(_val))) {
        this.numbersSplitted.push(Number(_val));
      } else {
        this.numbersSplitted.push(Number(_val));
      }
    }
  }
}
